"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _lodash2 = _interopRequireDefault(require("lodash.get")),
    _memoizeOne2 = _interopRequireDefault(require("memoize-one")),
    _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes")),
    _downloadFile = _interopRequireDefault(require("./utils/downloadFile"));

require("./styles/_download-asset-menu.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var LABELS_MAP = {
  ORIGINAL: "ORIGINAL QUALITY",
  HD: "HIGH RES",
  SD: "LOW RES",
  CAPTION: "CAPTION",
  VTT_CAPTION: "VTT CAPTION"
},
    CAPTION_TYPES = ["CAPTION", "VTT_CAPTION"],
    isCaption = function isCaption(type) {
  return CAPTION_TYPES.includes(type);
},
    isAssetFileValid = function isAssetFileValid(assetFile) {
  var type = assetFile.type,
      metaData = assetFile.metaData;
  return !!LABELS_MAP[type] && (!isCaption(type) || metaData && metaData.lang);
},
    getFileDetails = (0, _lodash["default"])(function (fileMetaData) {
  if (!fileMetaData) return "";
  var type = fileMetaData.type,
      size = fileMetaData.size,
      extension = type && type.split("/").pop(),
      fileSize = size && (0, _getDisplayBytes["default"])(size);
  return [extension, fileSize].filter(Boolean).join(" | ");
}),
    getOptionValues = function getOptionValues(_ref, assetId) {
  var type = _ref.type,
      metaData = _ref.metaData;
  return isCaption(type) ? {
    details: getFileDetails(metaData),
    label: "".concat(LABELS_MAP[type], " - ").concat(metaData.lang && metaData.lang.toUpperCase()),
    onClick: function onClick() {
      return (0, _downloadFile["default"])({
        assetId: assetId,
        assetFiles: "".concat(type, "_").concat(metaData.lang.toUpperCase())
      });
    }
  } : {
    label: LABELS_MAP[type],
    onClick: function onClick() {
      return (0, _downloadFile["default"])({
        assetId: assetId,
        assetFiles: type
      });
    },
    details: getFileDetails(metaData)
  };
},
    DownloadAssetMenu = function (_Component) {
  function DownloadAssetMenu() {
    var _temp, _this;

    (0, _classCallCheck2["default"])(this, DownloadAssetMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2["default"])(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.onOptionClick = (0, _lodash["default"])(function (onClick) {
      return function () {
        onClick(), _this.toggleMenu();
      };
    }), _this.state = {
      menuOpen: !1
    }, _this.getDownloadOptions = (0, _memoizeOne2["default"])(function (asset) {
      return asset && asset.assetFiles ? (0, _toConsumableArray2["default"])(Object.keys(asset.assetFiles)).filter(function (key) {
        return asset.assetFiles[key] && (Array.isArray(asset.assetFiles[key]) || "object" === (0, _typeof2["default"])(asset.assetFiles[key]));
      }).reduce(function (files, fileType) {
        return isCaption(fileType) && Array.isArray(asset.assetFiles[fileType]) ? [].concat((0, _toConsumableArray2["default"])(files), (0, _toConsumableArray2["default"])(asset.assetFiles[fileType])) : [].concat((0, _toConsumableArray2["default"])(files), [asset.assetFiles[fileType]]);
      }, []).map(function (assetFile) {
        if (!assetFile.metaData) return assetFile;

        try {
          var metaData = JSON.parse(assetFile.metaData);
          return _objectSpread({}, assetFile, {
            metaData: metaData
          });
        } catch (e) {
          return assetFile;
        }
      }).filter(isAssetFileValid).map(function (assetFile) {
        return getOptionValues(assetFile, asset.assetId);
      }) : null;
    }), _this.toggleMenu = function () {
      _this.setState(function (_ref2) {
        var menuOpen = _ref2.menuOpen;
        return {
          menuOpen: !menuOpen
        };
      }, function () {
        var menuOpen = _this.state.menuOpen;
        return menuOpen ? void document.addEventListener("mousedown", _this.handleClick) : void document.removeEventListener("mousedown", _this.handleClick);
      });
    }, _this.handleClick = function (event) {
      var menuOpen = _this.state.menuOpen;
      _this._menuRef && _this._menuRef.contains(event.target) || !menuOpen || _this.toggleMenu();
    }, _this.onButtonClick = function (options) {
      var asset = _this.props.asset,
          originalOption = options.find(function (_ref3) {
        var label = _ref3.label;
        return label === LABELS_MAP.ORIGINAL;
      });

      try {
        var _ref4 = JSON.parse((0, _lodash2["default"])(asset, "metaData", "")) || {},
            type = _ref4.type,
            isVideo = type.includes("video");

        return isVideo ? _this.toggleMenu : originalOption && originalOption.onClick;
      } catch (_unused) {
        return originalOption && originalOption.onClick;
      }
    }, _temp));
  }

  (0, _inherits2["default"])(DownloadAssetMenu, _Component);

  var _super = _createSuper(DownloadAssetMenu);

  return (0, _createClass2["default"])(DownloadAssetMenu, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props = this.props,
          children = _this$props.children,
          asset = _this$props.asset,
          menuOpen = this.state.menuOpen,
          options = this.getDownloadOptions(asset);

      return options && options.length ? _react["default"].createElement("div", {
        ref: function ref(node) {
          _this2._menuRef = node;
        },
        className: "download-asset-menu"
      }, _react["default"].cloneElement(children, {
        onClick: this.onButtonClick(options)
      }), menuOpen ? _react["default"].createElement("div", {
        className: "download-asset-menu__inner"
      }, options.map(function (_ref5) {
        var label = _ref5.label,
            onClick = _ref5.onClick,
            details = _ref5.details;
        return _react["default"].createElement("button", {
          key: label,
          type: "button",
          className: "download-asset-menu__option",
          onClick: _this2.onOptionClick(onClick)
        }, _react["default"].createElement("p", null, label), _react["default"].createElement("p", null, details));
      })) : null) : children;
    }
  }]), DownloadAssetMenu;
}(_react.Component);

exports["default"] = DownloadAssetMenu;